import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiRefreshCw,
  FiDownload,
  FiEye,
  FiCheckCircle,
  FiFileText,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function OrdersMonitor() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("failed");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [orders] = useState([
    {
      id: 1,
      orderId: "ORD-001",
      userId: "USR-001",
      userName: "Rajesh Kumar",
      schemeName: "HDFC Equity Fund",
      amount: 50000,
      orderType: "Lumpsum",
      status: "Failed",
      failureReason: "Insufficient funds",
      orderDate: "2024-01-20",
      partnerRef: "PRT-001",
    },
    {
      id: 2,
      orderId: "ORD-002",
      userId: "USR-002",
      userName: "Priya Sharma",
      schemeName: "ICICI Balanced Fund",
      amount: 25000,
      orderType: "Lumpsum",
      status: "Pending",
      failureReason: null,
      orderDate: "2024-01-20",
      partnerRef: "PRT-002",
    },
    {
      id: 3,
      orderId: "ORD-003",
      userId: "USR-003",
      userName: "Amit Patel",
      schemeName: "SBI Debt Fund",
      amount: 75000,
      orderType: "Lumpsum",
      status: "Failed",
      failureReason: "KYC incomplete",
      orderDate: "2024-01-19",
      partnerRef: "PRT-003",
    },
  ]);

  const handleResync = (orderId) => {
    Swal.fire({
      title: "Resync Order?",
      text: "This will trigger a resync with the partner system.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Resync",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Resync Started!", "Order resync process initiated.", "success");
      }
    });
  };

  const handleMarkResolved = (orderId) => {
    Swal.fire({
      title: "Mark as Resolved?",
      text: "This order will be marked as resolved.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Mark Resolved",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Resolved!", "Order marked as resolved.", "success");
      }
    });
  };

  const handleCreateTicket = (orderId) => {
    Swal.fire({
      title: "Create Support Ticket",
      html: `
        <input id="ticketSubject" class="swal2-input" placeholder="Ticket Subject" required>
        <textarea id="ticketDescription" class="swal2-textarea" placeholder="Description"></textarea>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Create Ticket",
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Ticket Created!", "Support ticket has been created.", "success");
      }
    });
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredOrders = orders.filter((order) => {
    const matchesSearch =
      order.orderId.includes(searchTerm) ||
      order.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.schemeName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || order.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredOrders.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                 <div className="content-page-header content-page-headersplit">
                <h5>Orders Monitor</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/mutual-funds/orders-monitor">Mutual Funds</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Orders Monitor
                  </li>
                </ol>
              </nav>
           
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
              {/* Filters */}
              <div className="row g-2 flex-grow-1">
                {/* Search */}
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by order ID, user name, or scheme..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>

                {/* Status Filter */}
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Failed">Failed</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="ms-md-3 mt-3 mt-md-0">
                <button className="btn btn-primary">
                  {/* <FiDownload className="me-2" /> */}
                  Export
                </button>
              </div>
              </div>
            </div>

            {/* Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>User</th>
                        <th>Scheme</th>
                        <th>Amount</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Failure Reason</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length === 0 ? (
                        <tr>
                          <td colSpan="8">No data available</td>
                        </tr>
                      ) : (
                        currentItems.map((order) => (
                          <tr key={order.id}>
                            <td style={{ fontWeight: "500" }}>{order.orderId}</td>
                            <td style={{ fontWeight: "500" }}>{order.userName}</td>
                            <td>{order.schemeName}</td>
                            <td style={{ fontWeight: "600" }}>{formatINR(order.amount)}</td>
                            <td>
                              <span className="badge" style={{
                                background: "#f0f9ff",
                                color: "#006e82",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: "600",
                              }}>
                                {order.orderType}
                              </span>
                            </td>
                            <td>
                              <span className={order.status === "Completed" ? "badge-active" : order.status === "Failed" ? "badge-pending" : "badge-pending"}>
                                {order.status}
                              </span>
                            </td>
                            <td>{order.failureReason || "-"}</td>
                            <td>
                              <div className="table-actions d-flex justify-content-center">
                                <div
                                  className="delete-table me-2"
                                  title="View Details"
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className="fas fa-eye"></i>
                                </div>
                                {order.status === "Failed" && (
                                  <>
                                    <div
                                      className="delete-table me-2"
                                      onClick={() => handleResync(order.orderId)}
                                      title="Resync Order"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <i className="fas fa-redo"></i>
                                    </div>
                                    <div
                                      className="delete-table me-2"
                                      onClick={() => handleMarkResolved(order.orderId)}
                                      title="Mark Resolved"
                                      style={{ cursor: "pointer", color: "#10b981" }}
                                    >
                                      <i className="fas fa-check-circle"></i>
                                    </div>
                                  </>
                                )}
                                <div
                                  className="delete-table"
                                  onClick={() => handleCreateTicket(order.orderId)}
                                  title="Create Ticket"
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className="fas fa-file-alt"></i>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
